import React from 'react'
import { useSearchParams } from "react-router-dom";
import fortuneLadyCoin from "../../assets/arts/lady token 1.svg";
import careersIcon from "../../assets/arts/careersIcon.png";
import { Box } from '@mui/material';
import SubHeader from '../SubHeader/SubHeader';

const ComingSoon = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    let pageName = searchParams.get("page");
    console.log(setSearchParams);
    return (
        <>
        <SubHeader/>
            <Box pt={23}>
                {pageName === "Careers" ? <img src={careersIcon} className="pt-5" alt="Coming soon art" width="400" />
                    :
                    <img src={fortuneLadyCoin} className="pt-5" alt="Coming soon art" width="400" />
                }
                <h1 className='coming_soon  font_60x'>
                    <span className='page_name'>{pageName} </span>
                    Coming Soon
                </h1>
                {pageName === "Careers" ? <div className='pt-4  text-center'>
                    <span className='font_20x  '>For inquiries, please reach us out at <a href='mailto:hr@indexx.ai' className='text_link ps-1'> hr@indexx.ai</a></span>
                </div>
                    :
                    <></>
                }
            </Box>

        </>
    )
}

export default ComingSoon